const Tick = (props) => {
  return (
	<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M25.3327 9.50709C24.9422 9.11657 24.309 9.11657 23.9185 9.50709L13.5577 19.8678C13.1672 20.2584 12.5341 20.2584 12.1435 19.8678L9.08155 16.8059C8.69102 16.4153 8.05786 16.4153 7.66733 16.8059L7.60713 16.8661C7.21661 17.2566 7.21661 17.8898 7.60713 18.2803L12.1435 22.8167C12.5341 23.2072 13.1672 23.2072 13.5577 22.8167L25.3929 10.9815C25.7834 10.591 25.7834 9.95782 25.3929 9.5673L25.3327 9.50709Z" fill="currentColor"/>
	</svg>
  );
};

export default Tick;
